import { ControlledConfirmation } from '@/components/AcknowledgeBox/Confirmation'
import { useFormContext } from 'react-hook-form'
import { classNames } from '@/util/tailwindHelpers'
import Link from 'next/link'

export const ConvertForm = ({ className }: { className?: string }) => {
  const { control } = useFormContext()

  return (
    <ControlledConfirmation
      className={classNames('bg-gray-800 mt-3', className)}
      required
      name={'confirm'}
      control={control}
    >
      I acknowledge that I am permanently destroying these items from my
      inventory. By proceeding I agree to the{' '}
      <Link
        href="/terms/arcade"
        className="inline-link"
        rel="noreferrer"
        target="_blank"
      >
        Arcade Rules
      </Link>
      .
    </ControlledConfirmation>
  )
}
